import assign from "lodash/fp/assign";
import startCase from "lodash/fp/startCase";
import map from "lodash/fp/map";
import moment from "moment";
import constants from "../../core/constants";

class BackupsPageTransform {
  constructor() {
    "ngInject";

    // NOTE: name is used for (user roles)
    this.item = {
      title: "Backup",
      state: "backup",
      name: "backup",
    };

    this.fields = [
      { title: "Captain", name: "captain" },
      { title: "Category", name: "category_name" },
      { title: "Status", name: "status" },
      { title: "Backup Station", name: "backup_station" },
      { title: "Bustype", name: "bus_type" },
      { title: "Station Arrival Status", name: "backup_station_status" },
      { title: "Start Date", name: "start_date" },
      { title: "End Date", name: "end_date" },
    ];

    this.filters = [
      {
        name: "captain",
        title: "Captain",
        icon: "person",
        resource: "Captain",
        hasExact: true,
        exactFields: ["name", "phone"],
        size: 25,
      },
      {
        name: "bus_type",
        title: "Bustype",
        icon: "directions_bus",
        resource: "Bustype",
      },
      {
        name: "status",
        title: "Status",
        icon: "person",
        list: "backupStatus",
        multiple: true,
      },
      { name: "date", title: "Select date", icon: "date_range", isDate: true },
      {
        name: "backup_station_status",
        title: "Station Arrival Status",
        icon: "person_pin",
        list: "backupStationStatus",
        multiple: true,
      },
    ];

    this.addOptions = {
      title: "Add New Backup",
      icon: "add",
      fields: [
        {
          resource: "Captain",
          name: "captain",
          title: "Captain",
          isResource: true,
          isRequired: false,
          hasExact: true,
          exactFields: ["name", "phone"],
        },
        {
          resource: "Bustype",
          name: "bus_type",
          title: "Bustype",
          isResource: true,
          isRequired: false,
        },
        {
          resource: "Bus",
          name: "bus",
          title: "Bus",
          isListResource: true,
          isRequired: false,
          requires: "captain",
          listTransformer: "BusesTransforms",
        },
        {
          name: "ride_category",
          title: "Ride Category",
          list: "rideCategoryList",
        },
        {
          name: "start_date",
          title: "Select start date",
          icon: "date_range",
          dateTime: true,
          hasRange: false,
        },
        {
          name: "end_date",
          title: "Select end date",
          icon: "date_range",
          dateTime: true,
          hasRange: false,
        },
        {
          resource: "Station",
          name: "backup_station",
          title: "Backup Station",
          isResource: true,
          isRequired: true,
        },
      ],
    };
  }

  justify(data) {
    const format = (item) => {
      item = assign({ _id: item._id }, item._source);
      item.category_name = item.ride_category
        ? `${startCase(item.ride_category.ride_type)} ${startCase(
            item.ride_category.service_type
          )}`
        : "";
      item.start_date = moment(item.start_date).format(
        constants.dateTimeFormat
      );
      item.end_date = moment(item.end_date).format(constants.dateTimeFormat);

      return item;
    };

    return map(format)(data);
  }
}

export default BackupsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/backups/backups.transforms.js